export default __webpack_public_path__ + "static/media/DA_DL.fc8906d7.png";